<template>
    <div>
        <ckeditor :editor="editor" v-model="editorData" :config="editorConfig" @input="onEditorInput"/>
    </div>
</template>

<script>
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
    import CKEditor from '@ckeditor/ckeditor5-vue'

    export default {
        name: 'CKEditor',
        components: {
            ckeditor: CKEditor.component
        },
        data: () => ({
            editor: ClassicEditor,
            editorData:'',
            //editorData: '<pre>입력해주세요</pre>',
            editorConfig: {
                // The configuration of the editor.
                height: '500px',
                language: 'ko',
                removePlugins : ['CKFinderUploadAdapter', 'CKFinder', 'EasyImage', 'Image', 'ImageCaption', 'ImageStyle', 'ImageToolbar', 'ImageUpload', 'MediaEmbed'],
                placeholder:"내용을 입력해주세요"
            }
        }),
        methods : {
            onEditorInput(){                
                this.$emit('getContents',this.editorData);
            }
        }
        
    }
</script>